import loadComponents from './components/index'
import loadBlocks from './blocks'

const attrSlider = 'data-slider'
const attrSliderItem = 'data-slider-item'
const attrSliderPrev = 'data-slider-prev'
const attrSliderNext = 'data-slider-next'
const attrSliderDots = 'data-slider-dots'
const attrSliderDot = 'data-slider-dot'

export default (editor, opts = {}) => {
  const options = { ...{
    // Object to extend the default slider block, eg. `{ label: 'Slider', attributes: { ... } }`
    // Pass a falsy value to avoid adding the block
    sliderBlock: {},

    // Object to extend the default slider properties, eg. `{ name: 'My Slider', draggable: false, ... }`
    sliderProps: {},
    
    // Object to extend the default slide properties
    slideProps: {},
    
    // Object to extend the default previous nav properties
    prevProps: {},
    
    // Object to extend the default next nav properties
    nextProps: {},
  
    // Object to extend the default dots properties
    dotsProps: {},

    // Object to extend the default dot properties
    dotProps: {},

    // Slider attribute identifier (main component)
    attrSlider,

    // Slider item attribute identifier
    attrSliderItem,

    // Slider prev attribute identifier
    attrSliderPrev,

    // Slider next attribute identifier
    attrSliderNext,

    // Slider dots attribute identifier
    attrSliderDots,

    // Slider dot attribute identifier
    attrSliderDot,
    
    // Class name for slider container
    classSlider: 'slider',
    
    // Class name for slide item
    classSlide: 'slider-item',
    
    // Class name for slider previous control
    classPrev: 'slider-prev',
    
    // Class name for slider next control
    classNext: 'slider-next',
    
    // Class name for slider dots control
    classDots: 'slider-dots',
    
    // Class name for slider dot control
    classDot: 'slider-dot',

    // Default template
    template: `
      <div ${attrSliderItem} class="slider-item"><div>Slider Content 1</div></div>
      <div ${attrSliderItem} class="slider-item"><div>Slider Content 2</div></div>
      <div ${attrSliderItem} class="slider-item"><div>Slider Content 3</div></div>
      <a ${attrSliderPrev} class="slider-prev material-icons">chevron_left</a>
      <a ${attrSliderNext} class="slider-next material-icons">chevron_right</a>
    `,

    // Default template for new added item content
    templateItemContent: `<div>Slider Content</div>`

  }, ...opts }

  // Add components
  loadComponents(editor, options)

  // Add blocks
  loadBlocks(editor, options)
}
